$(document).ready(function () {

    var visible = 3;

    if ($(window).width() > 1100) {
        visible = 3;
    }

    if ($(window).width() < 1100) {
        visible = 2;
    }

    if ($(window).width() < 600) {
        visible = 1;
    }

    $('.js-case-studies-carousel').initCycle({
        'slides': '> .js-case-study',
        'pageActiveClass': 'active',
        'fx': 'carousel',
        'carouselVisible': visible,
        'carouselFluid': true,
        'allowWrap': true,
        'next': '.js-cs-next',
        'prev': '.js-cs-prev',
        'timeout': 4000
    });

    $('.js-news-carousel').initCycle({
        'slides': '> .js-news-post',
        'pageActiveClass': 'active',
        'fx': 'carousel',
        'carouselVisible': visible,
        'carouselFluid': true,
        'allowWrap': true,
        'next': '.js-n-next',
        'prev': '.js-n-prev'
    });

    $('.js-review-carousel').initCycle({
        'slides': '> .js-r-slide',
        'pageActiveClass': 'active',
        'fx': 'carousel',
        'carouselVisible': 1,
        'carouselFluid': true,
        'allowWrap': true,
        'next': '.js-r-next',
        'prev': '.js-r-prev',
        'pager': '.js-review-pager'
    });

});